var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.src
    ? _c(
        "el-image",
        {
          staticClass: "flex-align-justify",
          style: _vm.style,
          attrs: { src: _vm.src, fit: _vm.fit, "preview-src-list": _vm.list },
        },
        [
          _c(
            "div",
            {
              staticClass: "image-slot",
              attrs: { slot: "placeholder" },
              slot: "placeholder",
            },
            [_c("i", { staticClass: "el-icon-loading is-loading" })]
          ),
          _c(
            "div",
            {
              staticClass: "image-slot",
              attrs: { slot: "error" },
              slot: "error",
            },
            [_c("i", { staticClass: "el-icon-picture-outline" })]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }